import type { Application, Income } from '@/types/Activity'

export const isStudentFinanceIncome = (type: string, status?: string) => {
  if (type.toLowerCase() === 'student' && status === 'Finance') {
    return true
  }

  return false
}

export const isEmploymentIncome = (type?: string) =>
  type && type.toLowerCase() === 'employment'

export const isAutomaticallyVerifiedIncome = (income: Income) => {
  const unsupportedIncomes = ['unemployment', 'up front', 'third party']

  const isStudentFinance = isStudentFinanceIncome(income.type, income.status)

  return isStudentFinance || unsupportedIncomes.includes(income.type.toLowerCase())
}

export const hasIncomeData = (application: Application): boolean =>
  application?.context?.incomes !== undefined && application?.context?.incomes?.length > 0
